var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import missedCallStrategy from "../details/receive/missed.call.strategy.constans";
import * as angular from 'angular';
import { reloadCurrentRoute } from '../../../../../src/app/shared/utils/navigate-force-reload';
var PhoneSettings = /** @class */ (function () {
    function PhoneSettings(InboundNumbersService, $stateParams, Toast, $state, $aside, $location, $translate, AmplitudeService, AuthService, Router) {
        this.InboundNumbersService = InboundNumbersService;
        this.$stateParams = $stateParams;
        this.toast = Toast;
        this.state = $state;
        this.$aside = $aside;
        this.$location = $location;
        this.$translate = $translate;
        this.receiveCallConfiguration = "receiveCallConfiguration";
        this.forwardCallConfiguration = "forwardCallConfiguration";
        this.dontAcceptCallConfiguration = "dontAcceptCallConfiguration";
        this.missedCallStrategy = "missedCallStrategy";
        this.amplitude = AmplitudeService;
        this.AuthService = AuthService;
        this.router = Router;
        this.voiceGlobalMessagesConfig = [{
                type: 'welcomeMessage',
                description: 'PHONE.MESSAGES.ROW_DESCRIPTION_WELCOME_MESSAGE',
                header: 'PHONE.MESSAGES.ROW_HEADER_WELCOME_MESSAGE',
                canBeEnabled: true
            }, {
                type: 'voiceMailDrop',
                description: 'PHONE.MESSAGES.ROW_DESCRIPTION_VOICEMAIL_DROP',
                header: 'PHONE.MESSAGES.ROW_HEADER_VOICEMAIL_DROP',
                canBeEnabled: true,
                permission: 'VOICE_MAIL_DROP_PERMISSION'
            },
        ];
    }
    PhoneSettings.prototype.$onInit = function () {
        var _this = this;
        this.user = this.AuthService.currentUser();
        this.amplitude.logEvent('Panel: Page View: Inbound settings');
        this.msisdn.initialLabel = this.msisdn.label;
        this.isNew = this.$stateParams.isNew;
        if (this.isNew)
            this.$location.search('isNew', null);
        if (this.number[this.missedCallStrategy]) {
            this.number[this.receiveCallConfiguration][this.missedCallStrategy] = this.number[this.missedCallStrategy];
        }
        Object.keys(this.number).forEach(function (key) {
            if (!angular.isObject(_this.number[key])) {
                return;
            }
            else if (_this.number[key]['checked']) {
                _this.number[key] = Object.assign({}, _this.number[key], { checked: true });
            }
            else {
                _this.number[key] = Object.assign({}, _this.number[key], { checked: false });
            }
        });
        this.activeMissedCall = this.isActiveMissedCall();
    };
    PhoneSettings.prototype.check = function (value) {
        var _this = this;
        var _a;
        if (this.isEmptyForwardCallConfigurationData(value)) {
            this.$aside({
                animation: "am-slide-right", placement: "right", container: "body",
                template: "<details-forward hide='$hide()' " +
                    "settings='$ctrl.number.forwardCallConfiguration' " +
                    "msisdnid='" + this.msisdn.id + "' " +
                    "class='aside col-lg-3 p-a-0 max-w-500' layout>" +
                    "</details-forward>"
            });
        }
        else {
            var currentMissedCallStrategy = this.number.missedCallStrategy;
            Object.keys(this.number).forEach(function (key) {
                if (angular.isObject(_this.number[key]) && !!_this.number[key].checked) {
                    _this.number[key] = __assign({}, _this.number[key], { checked: false });
                }
                if (key === _this.receiveCallConfiguration) {
                    _this.number[key] = __assign({}, _this.number[key], { missedCallStrategy: _this.number.missedCallStrategy });
                }
                return _this.number[key];
            });
            this.number = __assign({}, this.number, (_a = {}, _a[value] = __assign({}, this.number[value], { checked: !this.number[value].checked }), _a.missedCallStrategy = currentMissedCallStrategy, _a));
            this.InboundNumbersService.setNumberSettings({ id: this.msisdn.id }, this.number, function () {
                _this.toast.success('CHANGES_SAVED');
                reloadCurrentRoute(_this.router);
            });
        }
    };
    PhoneSettings.prototype.isEmptyForwardCallConfigurationData = function (value) {
        return value === this.forwardCallConfiguration && this.number[value].phoneNumber === "";
    };
    PhoneSettings.prototype.changeMissedCall = function () {
        if (this.isActiveMissedCall()) {
            this.number.receiveCallConfiguration.missedCallStrategy = 'DO_NOT_CALL_BACK';
            this.save('DO_NOT_CALL_BACK');
        }
        else {
            this.number.receiveCallConfiguration.missedCallStrategy = 'CALL_BACK_WITH_HIGHEST_PRIORITY';
            this.save('CALL_BACK_WITH_HIGHEST_PRIORITY');
        }
        this.activeMissedCall = this.isActiveMissedCall();
    };
    PhoneSettings.prototype.isActiveMissedCall = function () {
        return this.number.receiveCallConfiguration.missedCallStrategy === 'CALL_BACK_WITH_HIGHEST_PRIORITY';
    };
    PhoneSettings.prototype.save = function (missedCallStrategyState) {
        var _this = this;
        this.number = __assign({}, this.number, { missedCallStrategy: missedCallStrategyState });
        this.InboundNumbersService.setNumberSettings({ id: this.msisdn.id }, this.number, function () {
            _this.toast.success('CHANGES_SAVED');
        });
    };
    PhoneSettings.prototype.isReturnCallEnabled = function () {
        return this.number[this.receiveCallConfiguration][this.missedCallStrategy] === missedCallStrategy.CALL_BACK_WITH_HIGHEST_PRIORITY;
    };
    PhoneSettings.prototype.reloadState = function () {
        reloadCurrentRoute(this.router);
    };
    PhoneSettings.prototype.settingsChanged = function () {
        this.toast.success('CHANGES_SAVED');
    };
    PhoneSettings.prototype.clickOnDetailsReceive = function () {
        angular.element('#details-receive').triggerHandler('click');
    };
    PhoneSettings.prototype.upgradeAccount = function () {
        this.router.navigateByUrl('/my-account');
    };
    PhoneSettings.$inject = ['InboundNumbersService', '$stateParams', 'Toast', '$state', '$aside', '$location', '$translate', 'AmplitudeService', 'AuthService', 'Router'];
    return PhoneSettings;
}());
export default {
    controller: PhoneSettings,
    template: require('./settings.numbers.settings.html'),
    bindings: { number: '<', msisdn: '<', plan: '<', hasAutoAppliedEeaMsisdn: '<' }
};
